import { IPromoAvia } from 'widgets/avia'
import { PopularDirectionExcursions } from 'widgets/excursions/popular-directions'

import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

export const MainPageExcursions = {
  getPromotions(isPopular: boolean) {
    return clientApi.get<Response<PopularDirectionExcursions[]>>(
      `/excursions/directions?is_popular=${isPopular}`,
    )
  },

  getPromoList() {
    return clientApi.get<Response<IPromoAvia[]>>('/excursions/ads-baners')
  },
}
